import React from 'react';
const points = ['Estás harto de sacrificar tus fines de semana redactando planificaciones de campo.', 'Llegas a casa agotado y todavía tienes que preparar el entrenamiento de fútbol del día siguiente.', 'Sientes que tus jugadores de fútbol se han estancado y necesitan métodos de élite.', 'Quieres presentarte ante tu club o tu escuela de fútbol con un programa de excelencia.'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-103">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-104"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-105">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-12 text-center tracking-tight" data-id="element-106">
          Este material de FÚTBOL es para ti si...
        </h2>

        <div className="space-y-4" data-id="element-107">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group shadow-lg" data-id="element-108">
              <div className="w-8 h-8 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 group-hover:bg-check-green group-hover:border-check-green transition-colors shadow-[0_0_10px_rgba(16,185,129,0.2)]" data-id="element-109">
                <span className="text-check-green group-hover:text-white text-sm font-bold transition-colors" data-id="element-110">
                  ✓
                </span>
              </div>
              <p className="text-text-main text-lg font-medium leading-relaxed" data-id="element-111">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}